import React from 'react';
import { MapPin, CheckCircle, Clock, Shield, Phone } from 'lucide-react';
import { zones, companyInfo, images } from '../data/mock';
import { Button } from './ui/button';

const ZoneIntervention = () => {
  return (
    <section id="zone" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Zone d'intervention
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Nous intervenons sur <span className="text-teal-600">Cannes</span> et tout le <span className="text-sky-600">06</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Intervention rapide sur l'ensemble des Alpes-Maritimes. Nos techniciens sont près de chez vous !
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map / Image side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src={images.hero}
                alt="Zone d'intervention Cannes et Alpes-Maritimes"
                className="w-full h-[400px] object-cover"
                loading="lazy"
                decoding="async"
                width="600"
                height="400"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-sky-900/80 via-transparent to-transparent" />
              
              {/* Overlay content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3 text-white mb-3">
                  <MapPin className="text-lime-400" size={24} />
                  <span className="text-xl font-bold">Cannes & Alpes-Maritimes (06)</span>
                </div>
                <p className="text-sky-100">
                  Intervention en moins de 2h sur Cannes et communes limitrophes
                </p>
              </div>
            </div>

            {/* Floating badges */}
            <div className="absolute -top-4 -right-4 bg-lime-500 text-gray-900 px-4 py-2 rounded-xl shadow-lg font-bold flex items-center gap-2">
              <Clock size={18} />
              24h/24 - 7j/7
            </div>
            <div className="absolute -bottom-4 -left-4 bg-white text-sky-700 px-4 py-2 rounded-xl shadow-lg font-bold flex items-center gap-2">
              <Shield size={18} />
              Devis gratuit
            </div>
          </div>

          {/* Cities list */}
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              <MapPin className="text-sky-600" size={24} />
              Villes desservies
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
              {zones.map((zone, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 bg-slate-50 hover:bg-sky-50 px-4 py-3 rounded-xl transition-colors duration-300 border border-slate-100 hover:border-sky-200"
                >
                  <CheckCircle size={16} className="text-teal-500 flex-shrink-0" />
                  <span className="text-gray-700 text-sm font-medium">{zone}</span>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-sky-50 to-teal-50 rounded-2xl p-6 border border-sky-100">
              <p className="text-gray-700 mb-4">
                <strong>Vous ne trouvez pas votre commune ?</strong> Nous intervenons sur l'ensemble du département 06. N'hésitez pas à nous contacter pour vérifier notre disponibilité dans votre secteur.
              </p>
              <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}>
                <Button className="bg-sky-600 hover:bg-sky-700 text-white font-semibold px-6 py-3 rounded-xl">
                  <Phone size={18} className="mr-2" />
                  {companyInfo.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZoneIntervention;